import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  // 401 = token invalid/expired. A 403 only means "no session" when the server says no
  // token was sent - other 403s ("Admin access required", "sheet is locked") are
  // permission errors on a perfectly valid login and must not sign the user out.
  let sessionLost = response.status === 401;
  if (response.status === 403) {
    const body = await response.clone().json().catch(() => null);
    sessionLost = !!body && /no token provided/i.test(body.error || '');
  }
  if (sessionLost && window.location.pathname !== '/login') {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    window.location.href = '/login';
  }
  return response;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
